import StatsAPI from "./StatsAPI";

const StatsApiClient = new StatsAPI();

export default StatsApiClient;